import { AppState } from '../states/appState'
import { r360Api } from '../../services/services'
import { formatActivityType, formatDate, formatProjectPriority } from '@/app/utils/commonFunctions'

export const Actions = {
    GET_MOST_URGENT_ACTIVITIES_REQUEST: 'GET_MOST_URGENT_ACTIVITIES_REQUEST',
    GET_MOST_URGENT_ACTIVITIES_FAILURE: 'GET_MOST_URGENT_ACTIVITIES_FAILURE',
    GET_MOST_URGENT_ACTIVITIES_SUCCESS: 'GET_MOST_URGENT_ACTIVITIES_SUCCESS',
}

// GET MOST URGENT ACTIVITIES

export const getMostUrgentActivitiesRequest = () => {
    return { type: Actions.GET_MOST_URGENT_ACTIVITIES_REQUEST }
}

export const getMostUrgentActivitiesError = (error?: any) => {
    return { type: Actions.GET_MOST_URGENT_ACTIVITIES_FAILURE, error }
}

export const getMostUrgentActivitiesSuccess = (activities: any) => {
    return {
        type: Actions.GET_MOST_URGENT_ACTIVITIES_SUCCESS,
        activities,
    }
}

export const getMostUrgentActivities = () => {
    return (dispatch: any, getState: any) => {
        dispatch(getMostUrgentActivitiesRequest())
        let filters = (getState() as AppState).mostUrgentActivitiesReducer.filters
        filters.tab = 'to_me'
        filters.type = {
            value: ['task'],
        }
        filters.priority = {
            value: ['urgent'],
        }
        filters.start_date = {
            value: new Date(),
            orderBy: 'DESC',
        }
        filters.end_date = {
            value: new Date(),
            orderBy: 'DESC',
            hours: 23,
            minutes: 59,
            seconds: 59,
        }
        filters.useIntervalDate = true
        r360Api
            .GetActivities(filters)
            .then((res: any) => {
                if (res && res.data && res.data.activities) {
                    let tmpActivities = res.data.activities.map((a: any) => {
                        return {
                            id: a.id,
                            status: a.status,
                            isRead: a.is_read,
                            timeZone: a.timeZone,
                            title: a.project_name,
                            sourceModule: a.module,
                            store_ids: a.store_ids,
                            type: formatActivityType(a.type),
                            priority: formatProjectPriority(a.priority),
                            isMostUrgent: a.priority === 'standard' ? false : true,
                            time: formatDate(new Date(a.start_date).toString(), 'YYYY-MM-DD HH:mm'),
                            dueTime: formatDate(
                                new Date(a.end_date).toString(),
                                'YYYY-MM-DD HH:mm'
                            ),
                        }
                    })
                    dispatch(getMostUrgentActivitiesSuccess(tmpActivities))
                } else {
                    dispatch(getMostUrgentActivitiesError())
                }
            })
            .catch((error: Error) => {
                dispatch(getMostUrgentActivitiesError(error))
            })
    }
}
